<!-- ALERT & CONFIRM DIALOG -->
<p-confirmDialog [style]="{width: '450px'}"></p-confirmDialog>
<p-toast></p-toast>

<p-fieldset>
    <!-- HEADER -->
    <ng-template pTemplate="header">{{translations.lbl_participants}}</ng-template>

    <!-- TOOLBAR -->
    <p-toolbar styleClass="p-mb-4">
        <ng-template pTemplate="left">
            <button pButton pRipple label="{{translations.lbl_go_Back}}" icon="pi pi-chevron-left"
                class="p-button-warning p-mr-2" (click)="redirectParticipant()"></button>
        </ng-template>
    </p-toolbar>

    <!-- MAIN CONTENT -->
    <div class="p-grid">
        <div class="p-col-12 p-md-6">

            <!-- PARTICIPANT DETAIL INFO -->

            <p-panel>
                <div class="p-d-flex p-ai-center p-jc-between p-py-1">
                    <span>{{translations.lbl_church_name}}</span>
                    <span class="p-text-bold">{{schoolfpg != null ? schoolfpg.schoolFPG.name :""}}</span>
                </div>
                <div class="p-d-flex p-ai-center p-jc-between p-pt-1 p-py-1">
                    <span>{{translations.lbl_workshop}}</span>
                    <span class="p-text-bold">{{schoolfpg != null ? translations.lbl_school_prep_guides : ""}} </span>
                </div>
                <div class="p-d-flex p-ai-center p-jc-between p-pt-1 p-py-1">
                    <span>{{translations.lbl_schedule}}</span>
                    <span class="p-text-bold">{{schoolfpg != null ? schoolfpg.schoolFPG.fromTime : ""}} -
                        {{schoolfpg != null ? schoolfpg.schoolFPG.toTime : "POR DEFINIR"}}</span>
                </div>
            </p-panel>
        </div>
    </div>

    <!-- MAIN CARD -->
    <div class="card">

        <!-- GRID -->
        <div class="p-grid">
            <!-- 1ST SECTION INFO -->
            <div class="p-col-12 p-md-6">

                <div class="p-fluid">
                    <h5>{{translations.lbl_personal_information}}</h5>

                    <!-- Name -->
                    <div class="p-col-12">
                        <label for="namePart">{{translations.lbl_name}} <span style="color:red">
                                (*)</span></label>
                        <input type="text" maxlength="30" [(ngModel)]="namePart" pInputText>
                    </div>

                    <!-- Last name -->
                    <div class="p-col-12">
                        <label for="lastNamePart">{{translations.lbl_last_name}} <span style="color:red">
                                (*)</span></label>
                        <input type="text" maxlength="35" [(ngModel)]="lastNamePart" pInputText>
                    </div>
                    <div class="p-col-12">
                        <label for="identID">{{translations.lbl_issued_identity}} <span style="color:red">
                                (*)</span></label>
                        <input type="text" maxlength="20" [(ngModel)]="identID" pInputText>
                    </div>
                    <div class="p-col-12">
                        <label for="currJob">{{translations.lbl_current_job}} </label>
                        <input type="text" maxlength="25" [(ngModel)]="currJob" pInputText>
                    </div>
                    <!-- Gender -->
                    <div class="p-col-12">
                        <label for="listMarrStat">{{translations.lbl_marriage_status}} </label>
                        <p-dropdown [options]="listMarrStat" [(ngModel)]="selectedMarrStat"
                            placeholder="{{translations.lbl_select}} {{translations.lbl_marriage_status}}"
                            optionLabel="descrip" [showClear]="true"></p-dropdown>
                    </div>

                    <!-- Language -->
                    <div class="p-col-12">
                        <label for="listLanguage">{{translations.lbl_language}}</label>
                        <p-dropdown [options]="listLanguage" [(ngModel)]="selectedLanguage"
                            placeholder="{{translations.lbl_select}} {{translations.lbl_language}}" optionLabel="value"
                            [showClear]="true"></p-dropdown>
                    </div>

                    <!-- Age -->
                    <div class="p-col-12">
                        <div class=" p-fluid p-formgrid p-grid church_field">
                            <div class="p-col-12 p-md-6">
                                <label for="birthday">{{translations.lbl_birth_Date}} <span style="color:red">
                                        (*)</span></label>
                                <p-inputMask slotChar="DD/MM/YYYY"
                                    pattern="^(0[1-9]|1[0-9]|2[0-9]|3[0-1])/(0[1-9]|1[0-2])/(\d{4})$" mask="99/99/9999"
                                    [(ngModel)]="birthday" placeholder="DD/MM/YYYY"
                                    (keyup)="calculateAge()"></p-inputMask>

                            </div>
                            <div class="p-col-12 p-md-6">
                                <label for="age">{{translations.lbl_age}}</label>
                                <p-inputNumber [(ngModel)]="age" inputId="minmax" mode="decimal" [min]="18" [max]="100"
                                    [showButtons]="true" [disabled]="true"></p-inputNumber>
                            </div>
                        </div>
                    </div>

                    <!-- Gender -->
                    <div class="p-col-12">
                        <label for="listGender">{{translations.lbl_gender}} <span style="color:red"> (*)</span></label>
                        <p-dropdown [options]="listGender" [(ngModel)]="selectedGender"
                            placeholder="{{translations.lbl_select}} {{translations.lbl_gender}}" optionLabel="descrip"
                            [showClear]="true"></p-dropdown>
                    </div>


                    <!-- Email -->
                    <div class="p-col-12">
                        <label for="email">{{translations.lbl_email}}</label>
                        <input type="text" maxlength="50" [(ngModel)]="email" pInputText>
                    </div>

                    <!-- Phone -->
                    <div class="p-col-12">
                        <div class=" p-fluid p-formgrid p-grid church_field">
                            <div class="p-col-12 p-md-6">
                                <label for="cellPhone">{{translations.lbl_cell_phone}}</label>
                                <input maxlength="20" type="text" [(ngModel)]="cellPhone" pInputText>
                            </div>
                            <div class="p-col-12 p-md-6">
                                <label for="homeNumber">{{translations.lbl_home_phone}}</label>
                                <input maxlength="20" type="text" [(ngModel)]="homeNumber" pInputText>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <!-- 2ND SECTION INFO -->
            <div class="p-col-12 p-md-6">
                <div class="p-fluid">
                    <h5>{{translations.lbl_address}}</h5>

                    <div class="p-col-12">
                        <label for="listState">{{translations.lbl_state}} <span style="color:red">
                                (*)</span></label>
                        <p-dropdown [options]="listState" [(ngModel)]="selectedState"
                            placeholder="{{translations.lbl_select}} {{translations.lbl_state}}" optionLabel="descrip"
                            [showClear]="true" [filter]="true"></p-dropdown>
                    </div>

                    <div class="p-col-12">
                        <label for="city">{{translations.lbl_county_city}} <span style="color:red">
                                (*)</span></label>
                        <input maxlength="40" type="text" [(ngModel)]="city" pInputText>
                    </div>

                    <div class="p-col-12">
                        <label for="neight">{{translations.lbl_neightborhood}}<span style="color:red">
                                (*)</span> </label>
                        <input maxlength="30" type="text" [(ngModel)]="neight" pInputText>
                    </div>

                    <div class="p-col-12">
                        <label for="street">{{translations.lbl_street_and_number}}<span style="color:red">
                                (*)</span> </label>
                        <input maxlength="50" type="text" [(ngModel)]="street" pInputText>
                    </div>
                    <div class="p-col-12">
                        <label for="zipcode">{{translations.lbl_zip_code}} </label>
                        <input maxlength="10" type="text" [(ngModel)]="zipcode" maxlength="10" pInputText>
                    </div>

                    <!-- Historial de cambios-->
                    <div class="p-col-12">
                        <label for="labelAccordion">{{translations.lbl_history}}
                            {{translations.lbl_leaving_reason}}</label>
                        <p-accordion id="labelAccordion">
                            <ng-container *ngIf="fgChangesLog && fgChangesLog.length > 0; else noHistory">
                                <p-accordionTab *ngFor="let item of fgChangesLog" [header]="item.comments ">
                                    {{translations.lbl_id}} {{translations.lbl_guide}}: {{ (item.id.key1Id) }}<br />
                                    {{translations.lbl_date}} : {{ convertDateFormat(item.id.currDate) }}<br />
                                    {{translations.lbl_guide}} : {{ (item.id.fileId) }}
                                </p-accordionTab>
                            </ng-container>
                            <ng-template #noHistory>
                                <br /><br />
                                <p>{{translations.lbl_no}} {{translations.lbl_history}} {{translations.lbl_available}}
                                </p>
                            </ng-template>
                        </p-accordion>
                    </div>


                </div>
            </div>
        </div>
        <!-- BUTTONS SECTION-->
        <div class="p-grid">
            <div class="p-col-12 p-md-6"></div>
            <div class="p-col-12 p-md-6">
                <!-- Buttons -->
                <div class="p-col-12">
                    <div class=" p-fluid p-formgrid p-grid church_field">
                        <div class="p-col-12 p-md-4"></div>
                        <div class="p-col-12 p-md-4">
                            <div class="p-field">
                                <button pButton pRipple type="button" icon="pi pi-plus"
                                    label="{{translations.lbl_save}}"
                                    *ngIf="!this.participant || this.participant.guide && this.participant.guide.status!='B'"
                                    class="p-button-raised p-button-success" (click)="saveSchoolFg()"></button>
                            </div>
                        </div>
                        <div class="p-col-12 p-md-4">
                            <div class="p-field">
                                <button pButton pRipple type="button" icon="pi pi-trash"
                                    label="{{translations.lbl_delete}}"
                                    class="p-mr-2 p-mb-2 p-button-raised p-button-danger" (click)="deleteSchoolFG()"
                                    *ngIf="this.participant && this.participant.guide.status!='B'"
                                    [disabled]="this.participant != null ? false : true"></button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</p-fieldset>

<!-- Modal ya existe -->

<p-dialog header="{{translations.lbl_record_already_exists}}" [(visible)]="displayModalParticipantExists"
    styleClass="p-fluid" [modal]="true" [style]="{width: '50vw'}" [maximizable]="true" [baseZIndex]="10000"
    [draggable]="false" [resizable]="false">

    <div class="card">
        <!-- INPUTS -->
        <div class="p-grid">

            <!-- DETAIL -->
            <div class="p-col-12 p-md-12 p-sm-12">
                <!-- label for="addresssExists">{{translations.lbl_brief_description_circumstance}}</label-->
                <span class="p-input-icon-left">
                    <i class="pi pi-map-marker"></i>
                    <input id="addresssExists" [disabled]="true" type="text" pInputText
                        placeholder="{{translations.lbl_brief_description_circumstance}}"
                        [(ngModel)]="formattedReason" />
                </span>
            </div>

            <!-- STATUS 
            <div class="p-col-12 p-md-12 p-sm-12">
                <label for="addresssExists">{{translations.lbl_status}}</label>
                <span class="p-input-icon-left">
                    <i class="pi pi-map-marker"></i>
                    <input id="addresssExists" [disabled]="true" type="text" pInputText
                        placeholder="{{translations.lbl_status}}" [(ngModel)]="formattedStatus" />
                </span>
            </div> -->

            <!-- NAME -->
            <div class="p-col-12 p-md-6 p-sm-12">
                <div class="p-fluid">
                    <!-- Nombre -->
                    <label for="usernameExists">{{translations.lbl_name}}</label>
                    <span class="p-input-icon-left">
                        <i class="pi pi-user"></i>
                        <input id="usernameExists" [disabled]="true" type="text" pInputText
                            placeholder="{{translations.lbl_name}}"
                            [(ngModel)]="participantExists?.guideAddr?.guide.name" />
                    </span>
                    <br />

                    <!-- Apellidos -->
                    <label for="lastnameExists">{{translations.lbl_last_name}}</label>
                    <span class="p-input-icon-left">
                        <i class="pi pi-user-minus"></i>
                        <input id="lastnameExists" [disabled]="true" type="text" pInputText
                            placeholder="{{translations.lbl_last_name}}"
                            [(ngModel)]="participantExists?.guideAddr?.guide.lastName" />
                    </span>
                    <br />
                </div>
            </div>

            <!-- LAST NAME-->
            <div class="p-col-12 p-md-6 p-sm-12">
                <div class="p-fluid">
                    <!-- Fecha de nacimiento -->
                    <label for="dateExists">{{translations.lbl_birth_Date}}</label>
                    <span class="p-input-icon-left">
                        <p-inputMask [disabled]="true" id="dateExists" slotChar="DD/MM/YYYY"
                            pattern="^(0[1-9]|1[0-9]|2[0-9]|3[0-1])/(0[1-9]|1[0-2])/(\d{4})$" mask="99/99/9999"
                            [(ngModel)]="formattedDateExists" placeholder="DD/MM/YYYY"></p-inputMask>
                    </span>
                    <br />

                    <!-- Genero -->
                    <label for="genderExists">{{translations.lbl_gender}}</label>
                    <span class="p-input-icon-left">
                        <i class="pi pi-users"></i>
                        <input id="genderExists" [disabled]="true" type="text" pInputText
                            placeholder="{{translations.lbl_gender}}" [(ngModel)]="formattedGenderExists" />
                    </span>
                    <br />
                </div>
            </div>

            <!-- ADDRESS-->
            <div class="p-col-12 p-md-12 p-sm-12">
                <!-- Domicilio -->
                <label for="addresssExists">{{translations.lbl_address}}</label>
                <span class="p-input-icon-left">
                    <i class="pi pi-map-marker"></i>
                    <input id="addresssExists" [disabled]="true" type="text" pInputText
                        placeholder="{{translations.lbl_address}}" [(ngModel)]="formattedAddressExists" />
                </span>
                <br />
            </div>


            <div class="p-col-12 p-md-12 p-sm-12 p-d-flex p-jc-end">
                <button pButton pRipple label="{{translations.lbl_discard}} {{translations.lbl_duplicated}}"
                    pTooltip="{{translations.lbl_discard}} {{translations.lbl_duplicated}}" icon="pi pi-chevron-left"
                    class="p-button-warning p-mr-2  text-ellipsis" (click)="closeModalParticipant();"></button>
                <button pButton pRipple type="button" icon="pi pi-check" label="{{translations.lbl_recover_record}}"
                    pTooltip="{{translations.lbl_recover_record}}" class="p-button-raised p-button-success  text-ellipsis"
                    (click)="closeModalParticipantExists()"></button>
            </div>


            <br />

            <!-- Historial de cambios-->
            <div class="p-col-12 p-md-12 p-sm-12">
                <label for="labelAccordion">{{translations.lbl_history}} {{translations.lbl_leaving_reason}}</label>

                <p-accordion id="labelAccordion">
                    <br />
                    <ng-container *ngIf="fgChangesLog && fgChangesLog.length > 0; else noHistory">
                        <p-accordionTab *ngFor="let item of fgChangesLog" [header]="item.comments ">
                            {{translations.lbl_id}} {{translations.lbl_guide}}: {{ (item.id.key1Id) }}<br />
                            {{translations.lbl_date}} : {{ convertDateFormat(item.id.currDate) }}<br />
                            {{translations.lbl_guide}} : {{ (item.id.fileId) }}
                        </p-accordionTab>
                    </ng-container>
                    <ng-template #noHistory>
                        <br /><br />
                        <p>{{translations.lbl_no}} {{translations.lbl_history}} {{translations.lbl_available}}</p>
                    </ng-template>
                </p-accordion>
            </div>
        </div>
    </div>
</p-dialog>